<template>
    <section v-if="user">
        <div class="bg-image" >
            <div class="bg-gray-lighter">
                <div class="content-full">
                    <div class="d-flex justify-content-between align-items-center">
                        <h1 class="flex-fill font-size-h2 my-2" v-if="user">
                            <img v-if="user.social_avatar.avatar !== null" class="img-avatar img-avatar-thumb img-avatar-rounded ml-4" :src="user.social_avatar.avatar" alt="">
                            <avatar :size="800" default-img="identicon" v-else  class="img-avatar img-avatar-rounded img-avatar-thumb ml-4" :email="user.email"></avatar>
                            {{user.name}}
                        </h1>
                        {{user.social_nickname}}
                        <router-link to="/users/profile/edit" class="btn btn-primary mr-2">
                            <i class="si si-pencil"></i><span class="d-none d-sm-inline ml-1"> Edit Profile</span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-full content-boxed">
            <div class="col-lg-12 p-0">
                <el-tabs type="border-card">
                    <el-tab-pane>
                        <span slot="label"><i class="si si-settings"></i> Profile</span>

                        <div class="row">
                            <div class="col-md-6">
                                <ul class="list-group push">
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <strong class="font-weight-bolder">Name :</strong>
                                        <strong>{{user.name}}</strong>
                                        <i class="material-icons-outlined">
                                            account_circle
                                        </i>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <strong class="font-weight-bolder">Email :</strong>
                                        <strong>{{user.email}}</strong>
                                        <i class="material-icons-outlined">
                                            email
                                        </i>
                                    </li>

                                </ul>
                            </div>
                            <div class="col-md-6">
                                <ul class="list-group push">
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <strong class="font-weight-bolder">Company :</strong>
                                        <strong>{{user.company || "Not Set"}}</strong>
                                        <i class="material-icons-outlined">
                                            business
                                        </i>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <strong class="font-weight-bolder">Phone Number :</strong>
                                        <strong>{{user.phoneNumber}}</strong>
                                        <i class="material-icons-outlined">
                                            call
                                        </i>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane>
                        <span slot="label"><i class="si si-key"></i>API Credentials</span>
                        <div class="block block-rounded block-fx-pop">
                            <div class="block-header block-header-default">
                                <div class="block-title">Project Apps</div>
                                <div class="block-options">
                                    <router-link class="btn btn-sm btn-outline-primary" :to="`/users/apps/create`">
                                        <i class="fa fa-plus pr-1"></i> Create App
                                    </router-link>
                                </div>
                            </div>
                            <div class="block-content block-content-full" v-loading="loading">
                                <table class="table mt-0 table-striped">
                                    <thead class="thead-dark">
                                    <tr>
                                        <td>#</td>
                                        <td>App Name</td>
                                        <td>Client ID</td>
                                        <td>Client Secret</td>
                                        <td>Actions</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(client, index) in apps" :key="index">
                                        <td>{{++index}}</td>
                                        <td>{{client.name}}</td>
                                        <td>
                                            <code class="small">{{client.app_id}}</code>
                                        </td>
                                        <td>
                                            <code class="small">{{client.app_secret}}</code>
                                        </td>
                                        <td>
                                            <button @click="revokeApp(client)" class="btn btn-sm btn-outline-danger">
                                                Revoke
                                            </button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex';
    import GravatarImg from "vue-gravatar";

    export default {
        components: {GravatarImg},
        data() {
            return {
                activeName: 'first'
            }
        },
        computed: {
            ...mapGetters({
                apps: 'getApps',
                loading: 'getLoadingStatus'
            })
        },
        methods: {
            handleClick(tab, event) {
                return true;
            },

            revokeApp(client) {
                this.$confirm(`Are you sure you want to revoke the app ${client.name}`, 'warning').then(() => {
                    this.$store.dispatch('revokeApiApp', {id: client.app_id})
                })
            },
            getApiApps() {
                this.$store.dispatch('loadApps')
            }
        },
        mounted() {
            this.getApiApps()
        }
    }
</script>

<style scoped>

</style>
